module.exports = __webpack_public_path__ + "static/img/ic_download.8ce91f0e.svg";